module.exports = __webpack_public_path__ + "static/responsive-design-137c9553128efde84f3ad69714e2bb4e.svg";